// 审核中
export const GIFT_VERIFYING = 3
// 审核不通过
export const GIFT_REJECTED = 4
